import {Box} from '@mui/material';
import {CountryIso2} from 'react-international-phone';

import InputTextField from '@/app/shared-components/InputTextField/InputTextField';
import 'react-international-phone/style.css';
import './styles/InternationalPhoneInput.scss';
import PhoneMaskedInput from '@/app/shared-components/InputTextField/PhoneMaskedInput';

import {PHONE_MAX_LENGTH} from './constants';
import {CountrySelect} from './CountrySelect';
import {useActions} from './useActions';

interface InternationalPhoneInputProps {
  setPhoneNumber?: string;
  defaultCountry?: CountryIso2;
  countries?: CountryIso2[];
  autocomplete?: string;
  label?: string;
  placeholder?: string;
  id?: string;
  isDisabled?: boolean;
  onChange?: (isValid: boolean, phone: string) => void;
  customError?: string;
  showCountryCode?: boolean;
}

export function InternationalPhoneInput({
  setPhoneNumber,
  defaultCountry,
  countries,
  autocomplete,
  label,
  placeholder,
  id,
  isDisabled = false,
  onChange,
  customError,
  showCountryCode = false,
}: InternationalPhoneInputProps) {
  const {
    inputRef,
    country,
    setCountry,
    allowedCountries,
    errorMessage,
    isValid,
    phoneValue,
    handlePaste,
    handleDisplayChange,
  } = useActions({
    setPhoneNumber,
    defaultCountry,
    countries,
    onChange,
    customError,
  });

  return (
    <Box className="international-phone-input-container">
      {showCountryCode && (
        <CountrySelect
          id={id ? `${id}_country_select` : null}
          country={country}
          setCountry={setCountry}
          countries={allowedCountries}
          disabled={isDisabled}
        />
      )}

      <InputTextField
        id={id ? `${id}_input_text_field` : null}
        label={label}
        placeholder={placeholder}
        value={phoneValue.replace(`+${country?.dialCode}`, '')}
        autoComplete={autocomplete}
        onChange={handleDisplayChange}
        onPaste={handlePaste}
        type="tel"
        inputRef={inputRef}
        error={!isValid}
        disabled={!!isDisabled}
        maxLength={PHONE_MAX_LENGTH}
        helperText={errorMessage}
        maskedInput={PhoneMaskedInput}
      />
    </Box>
  );
}
